// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 16", width: "18", height: "16" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("path", { fillRule: "nonzero", d: "M16,0 C17.1045695,0 18,0.8954305 18,2 L18,14 C18,15.1045695 17.1045695,16 16,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,2 C0,0.8954305 0.8954305,0 2,0 L16,0 Z M16,2 L2,2 L2,14 L16,14 L16,2 Z M7,8 L7,12 L5,12 L5,8 L7,8 Z M10,6 L10,12 L8,12 L8,6 L10,6 Z M13,4 L13,12 L11,12 L11,4 L13,4 Z" }))));
};
Icon.displayName = 'ChartCard18x16';
export default Icon;
//# sourceMappingURL=ChartCard18x16.js.map